import { createSlice} from '@reduxjs/toolkit';
import { apiCallBegan } from './api';
import _ from 'lodash';
// import moment from 'moment';

function pad(num) {
  return num < 10 ? '0' + num : num;
}
let curDate = new Date()
let formattedDate = `${curDate.getFullYear()}-${pad(curDate.getMonth() + 1)}-${pad(curDate.getDate())}`

const slice = createSlice({
  name: 'flights',
  initialState: {
    airline: '',
    list: [],
    movingFlight: '',
    flightDate: formattedDate,
    loading: false,
    editReqStatus: 'Default'
  },
  reducers: {
    setAirline: (state, action) => {
      state.airline = action.payload
    },
    flightsRequested: (state, action) => {
      state.loading = true
    },
    loadFlightsSuccess: (state, action) => {
      state.list = action.payload;
      state.loading = false;
    },
    loadFlightsError: (state, action) => {
      console.log(`loadFlights err: ${action.payload}`)
    },
    setFlightDate: (state, action) => {
      state.flightDate = action.payload
    },
    moveFlightRequested: (state, action) => {
      state.movingFlight = action.payload
    },
    moveFlightSuccess: (state, action) => {
      state.editReqStatus = 'Success'
      let listCopy = _.cloneDeep(state.list)
      let movingFlightCopy = _.cloneDeep(state.movingFlight)
      let editedFlightLoc = listCopy.findIndex(flight => flight.FlightNumber === movingFlightCopy.flightNumber)
      listCopy[editedFlightLoc].ETD = `${_.clone(state.flightDate)}  ` + movingFlightCopy.dep
      listCopy[editedFlightLoc].ETA = `${_.clone(state.flightDate)}  ` + movingFlightCopy.arr
      state.movingFlight = ''
      state.list = listCopy
    },
    moveFlightError: (state, action) => {
      state.editReqStatus = 'Failure'
    },
    editFlightRequested: (state, action) => {
      state.editReqStatus = 'Loading'
    },
    editFlightSuccess: (state, action) => {
      state.editReqStatus = 'Success'
    },
    editFlightFailure: (state, action) => {
      state.editReqStatus = 'Failure'
    },
    resetEditReqStatus: (state, action) => {
      state.editReqStatus = 'Default'
    }
  }
})

// NOTE // actions for use in api requests
const { loadFlightsSuccess, loadFlightsError, flightsRequested, moveFlightRequested, moveFlightSuccess, moveFlightError, editFlightRequested, editFlightSuccess, editFlightFailure } = slice.actions
// NOTE // actions for use in components
export const { setAirline, setFlightDate, resetEditReqStatus } = slice.actions;
export default slice.reducer;

export const loadFlights = (flightDate) => (dispatch, getState) => {
  // const flightNum = getState().entities.flights.flightNumber
  const url = `getOps`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {date: flightDate, airlineId: getState().entities.flights.airline},
      onStart: flightsRequested.type,
      onSuccess: loadFlightsSuccess.type,
      onError: loadFlightsError.type,
    })
  )
}

// export const moveFlight = (editData, flightNumber, type) => (dispatch, getState) => {
//   // req.body.editData, req.body.flightNumber, req.body.type, req.body.airlineId
//   const url = `editFlightData`

//   return dispatch(
//     apiCallBegan({
//       url,
//       method: 'post',
//       data: {editData: editData, flightNumber: flightNumber, type: type, airlineId: getState().entities.flights.airline},
//       onStart: moveFlightRequested.type,
//       onSuccess: moveFlightSuccess.type,
//       onError: moveFlightError.type,
//     })
//   )
// }

export const editFlight = (data) => (dispatch, getState) => {
  const url = `editFlightData`
  data.airlineId = getState().entities.flights.airline
  data.editData.airlineId = data.airline

  if (data.type === 'updateFlightTime') {
    dispatch(moveFlightRequested({flightNumber: data.flightNumber, dep: data.editData.departureTime, arr: data.editData.arrivalTime}))

    return dispatch(
      apiCallBegan({
        url,
        method: 'post',
        data: data,
        onStart: editFlightRequested.type,
        onSuccess: moveFlightSuccess.type,
        onError: moveFlightError.type,
      })
    )
  }
  else {
    return dispatch(
      apiCallBegan({
        url,
        method: 'post',
        data: data,
        onStart: editFlightRequested.type,
        onSuccess: editFlightSuccess.type,
        onError: editFlightFailure.type,
      })
    )
  }
}